(function($, undefined) {

	/**
	 * @author Radek Šerý
	 *
	 * Kliknutí na seřazení dle vzdálenosti. Před odesláním získá pomocí API pozici, vyplní ji do inputu a odešle
	 * formulář.
	 */
	$.nette.pd.ext('geolocation', {
		init: function() {
		},
		before: function (xhr, settings) {
			var ext = this;

			// Pokud už máme pozici, odešleme formulář
			if ('nette' in settings && this.hasPosition) {
				this.hasPosition = false;
				return true;
			}

			// Pozici nemáme, pokusíme se ji zjistit
			if ('geolocation' in navigator) {
				navigator.geolocation.getCurrentPosition(function (position) {
					ext.geoSuccess.call(ext, xhr, settings, position);
				}, function (error) {
					ext.geoError.call(ext, xhr, settings, error);
				}, ext.geoOptions);
			}

			// Formulář odešleme sami v případě úspěchu
			return false;
		},
		start: function () {
			this.hasPosition = false;
		},
		success: function() {
			this.hasPosition = false;
		}
	}, {
		hasPosition: false,
		geoOptions: {
			enableHighAccuracy: true,
			maximumAge: 30000,
			timeout: 27000
		},
		geoSuccess: function(xhr, settings, position) {
			if ('nette' in settings) {
				settings.nette.form.find('.js-geolocation__latitude').val(position.coords.latitude);
				settings.nette.form.find('.js-geolocation__longitude').val(position.coords.longitude);

				this.hasPosition = true;

				// pokud chci odeslat neajaxový formulář, tak před klikem odstraním class ajax
				if (settings.nette.el.hasClass( "js-form-submit-no-ajax" )){
					settings.nette.el.removeClass('ajax');
				}
				settings.nette.el.click();
			}
		},
		geoError: function(xhr, settings, error) {
			var message = '';

			if ('nette' in settings) {
				message = settings.nette.el.data('geolocation-error') || '';
			}

			alert(message + ' ' + error.message);
		}
	});

})(jQuery);
